module.exports = __webpack_public_path__ + "static/avatar_director-2c506c452e2121343fb6bd55ee2f82d0.jpg";